import React from "react";
import { Link } from "react-router-dom";
import axios from "axios";

function EndButton({
  survey,
  element,
  nxtQuestion,
  items,
  setItems,
  data,
  setData,
  percentComplete,
  setPercent,
  buttonEnabled,
  setButtonEnable,
}) {
  //fetch to php file
  const fetchRequest = () => {
    const url =
      window.location.protocol +
      "//" +
      window.location.host +
      "/evaluacion-docente/";
    // const url = "http://localhost:88/evaluacion-docente/";
    axios
      .post(`${url}agregar.php`, items)
      .then((result) => {
        window.location.href = result.data.redirect;
      })
      .catch((error) => {
        window.location.href = url + "r_error.php";
      });
  };
  // Function to addItems to array
  const addItem = () => {
    const newResponse = { questionID: element.id, reply: data };
    const aux = items;
    let questionsArray = items.ObjectToSave.answers;
    if (questionsArray.length !== 0) {
      if (!questionsArray.some((v) => v.id === newResponse.questionID)) {
        questionsArray.push(newResponse);
      } else {
        questionsArray = updateQuestion(
          questionsArray,
          newResponse.questionID,
          newResponse.reply,
        );
      }
    } else {
      questionsArray.push(newResponse);
    }
    aux.ObjectToSave.answers = questionsArray;
    setItems(aux);
    setData();
    let newPercent = 0;
    if (items.ObjectToSave.answers.length + 1 <= survey.length) {
      newPercent =
        ((items.ObjectToSave.answers.length + 1) * 100) / survey.length;
    } else {
      newPercent = 100;
    }
    setPercent(Math.round(newPercent));
    setButtonEnable(false);
  };

  // Function to update an answer if already exist
  function updateQuestion(array, ID, newAnswer) {
    for (let i in array) {
      if (array[i].ID === ID) {
        array[i].reply = newAnswer;
        break; //Stop this loop
      }
    }
    return array;
  }

  // Function to render submit form
  function ButtonToEnd() {
    if (buttonEnabled) {
      return (
        <div>
          <button
            className="specialButton button"
            onClick={() => {
              addItem();
              fetchRequest();
            }}
          >
            ENVIAR
          </button>
        </div>
      );
    } else {
      return (
        <div>
          <button
            disabled={true}
            className="button"
            onClick={() => {
              addItem();
              fetchRequest();
            }}
          >
            ENVIAR
          </button>
        </div>
      );
    }
  }

  // Function to render button for next question
  function ButtonToContinue({ nxtQuestion }) {
    if (buttonEnabled) {
      return (
        <Link to={nxtQuestion}>
          <button className="specialButton button" onClick={addItem}>
            CONTINUAR &gt;
          </button>
        </Link>
      );
    } else {
      return (
        <Link to={nxtQuestion}>
          <button disabled={true} className="button" onClick={addItem}>
            CONTINUAR &gt;
          </button>
        </Link>
      );
    }
  }

  if (nxtQuestion !== "END") {
    return <ButtonToContinue nxtQuestion={nxtQuestion} />;
  } else {
    return <ButtonToEnd />;
  }
}

export default EndButton;
